<i18n lang='yml' src='../i18n/ExamIndex.yml'></i18n>
<template>
    <div>
      <div class="layout-tile">
        <div class="heading-block d-flex">
        <h4>
          {{ $t('header') }}
        </h4>
          <a v-if="edit_permission == 'true'" class="btn btn-sm btn-success ml-auto" :href="`${base_path}/new`">
            <font-awesome-icon :icon="['fas', 'plus']"/>
            {{ $t('new_exam') }}
          </a>
        </div>
      </div>
      <filter-bar :filter_params="filter_params" :filter_path="filter_path"></filter-bar>
      <div class="media-list">
        <div class="content-block" v-for="item in examListItems" :key="item.id">
          <div class="post-meta">
            <ul class="list-inline list-annotation">
              <li>
                <h5 class="container-item-name">
                  <a :href="`${base_path}/${item.id}`"> {{`${item.test_id} - ${item.name[locale]}`}}  </a>
                </h5>
              </li>
              <li class="ml-auto" v-if="edit_permission == 'true'">

                <div class="btn-group btn-group-sm ml-auto" role="group">
                  <a class="btn btn-outline-success" :href="`${base_path}/${item.id}/clone`">
                    <font-awesome-icon :icon="['far', 'copy']"/>
                    <span> {{ $t('new_version') }} </span>
                  </a>
                </div>
                <div class="btn-group btn-group-sm ml-auto" role="group">
                  <a class="btn btn-outline-primary" :href="`${base_path}/${item.id}/edit`">
                    <font-awesome-icon :icon="['fas', 'edit']"/>
                    <span> {{ $t('edit') }} </span>
                  </a>
                </div>
              </li>
            </ul>
          </div>
          <div class="post-meta">
            <ul class="list-unstyled list-inline list-annotation">
              <li class="list-inline-item"> 
                <span class="status-bold">{{$t('version')}}</span>
                {{ item.version_name}}
              </li>
              <li class="list-inline-item">
                <span class="status-bold">{{ $t('exam_type') }}</span>
                {{ item.exam_type.name[locale]}}
              </li>
              <li class="list-inline-item">
                <span class="status-bold">{{ $t('inter_provincial_exam') }}</span>
                {{ item.inter_provincial_exam? $t('yes_val') : $t('no_val')}}
              </li>
              <li class="list-inline-item">
                <span class="status-bold">{{ $t('exam_status')}}</span>
                {{ $t(item.status)}} 
              </li>
              <li class="list-inline-item">
                <span class="status-bold">{{ $t('status_date')}}</span>
                {{ formatDate(item.updated_at) }}   
              </li>
              <li class="list-inline-item">
                <span class="status-bold">{{ $t('trade_associations')}}</span>
                {{ fetchTradeCodes(item.exam_program_associations) }}
              </li>
              <li class="list-inline-item">
                <span class="status-bold">{{$t('inventory_available') }}</span>
                {{ item.received_inventory_count }} 
              </li>
            </ul>
          </div>
        </div>

      </div>
      <div v-if="examList.length == 0">
        <div class="alert alert-warning" role="alert">
          {{noDataError}}
        </div>
      </div>
       <pagination @items_changed="setItems" :items="examList" :expansion_threshold="expansion_threshold" :pagination_limit="pagination_limit"/>
    </div>
</template>

<script>
import Main from '../../../../filter_bar/components/Main.vue';
import Pagination from '../../../../shared/pagination/Pagination.vue';
import {formatDate} from '../../../../shared/typescripts/dates.ts'

  export default {
    props: ['locale', 'exams', 'filter_params', 'filter_path','base_path', 'edit_permission', 'pagination_limit', 'expansion_threshold'],

    components: {
      'filter-bar': Main,
      'pagination': Pagination,  
    },

    data() {
      return {
        examList: [],
        examListItems: [],
        loading: false,
        error: false,
        filterParams: null,
      }
    },

    mounted() {
      this.$i18n.locale = this.locale;
      this.filterParams = this.filter_params
      try{
        this.examList = JSON.parse(this.exams) || [];
      }
      catch(err){
        this.error = true;
      }
    },
    computed: {

      noDataError: function() {
        let params;
        try {
          params = JSON.parse(this.filter_params)
          if (params){
            return params['search'].value ? this.$t('no_search') : this.$t('no_data') ;
          }
        }
        catch(err) {
          this.error = true;  
        }    
      },
    },

    methods: {
      formatDate(dateString) {
        return formatDate(dateString)
      },
      sortBooksByStatus(inventory_items, status) {
        let returnItems = []
        console.log(inventory_items)

        if(inventory_items.length > 0){
          inventory_items.forEach((item) => {
            if(item.status == status){
              returnItems.push(parseInt(item.code))
            }
          })
        }
        if(returnItems.length <= 0){
          return this.$i18n.t('none')
        }

        return returnItems.length
      },

      fetchTradeCodes(associations) {
        let returnData = []
        if(associations.length == 0) {
          return this.$i18n.t('none');
        }
        else {
          associations.forEach((programAssociation) => {
            returnData.push(programAssociation.training_program.trade_code);
          })
        }
        return returnData.join(', ');
      },
      setItems(items) {
        this.examListItems = items
      }

    }
 }
</script>
